module.exports = __webpack_public_path__ + "static/media/afterlife-square.9943753d.png";